import { Select, Space, Tooltip, Button } from "antd";
import { ClearOutlined } from "@ant-design/icons";

export default function ProductosFilters({
  proyectos = [],
  municipios = [],
  pos = [],
  filters,
  onFilter,
  onClear,
  extra
}) {
  return (
    <Space
      style={{
        marginBottom: 16,
        display: "flex",
        justifyContent: "space-between",
        width: "100%"
      }}
      wrap
    >
      {/* 🔍 FILTROS */}
      <Space wrap>
        {/* 🔹 PO */}
        <Select
          placeholder="Orden de Compra (PO)"
          style={{ width: 180 }}
          allowClear
          showSearch
          value={filters.po}
          onChange={(v) => onFilter("po", v)}
          options={pos.map(p => ({
            label: p,
            value: p
          }))}
        />

        {/* 🔹 MUNICIPIO */}
        <Select
          placeholder="Municipio"
          style={{ width: 200 }}
          allowClear
          showSearch
          value={filters.municipio}
          onChange={(v) => onFilter("municipio", v)}
          options={municipios.map(m => ({
            label: m,
            value: m
          }))}
        />

        {/* 🔹 PROYECTO */}
        <Select
          placeholder="Proyecto"
          style={{ width: 260 }}
          allowClear
          showSearch
          value={filters.proyecto}
          onChange={(v) => onFilter("proyecto", v)}
          options={proyectos.map(p => ({
            label: p.proyecto,
            value: p.codigo
          }))}
        />

        {/* 🔥 LIMPIAR */}
        <Tooltip title="Limpiar filtros">
          <Button icon={<ClearOutlined />} onClick={onClear}>
            Limpiar
          </Button>
        </Tooltip>
      </Space>

      {/* ⚡ ACCIONES (EXPORT, ETC) */}
      <Space>{extra}</Space>
    </Space>
  );
}